import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import PreConDocument from '../components/field-report/PreConDocument';
import FieldReportToolbar from '../components/field-report/FieldReportToolbar';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PreConPreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await axios.get(`${API}/precons/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setReport(response.data);
      } catch (error) {
        console.error('Failed to fetch precon report:', error);
        toast.error('Failed to load precon report');
      } finally {
        setLoading(false);
      }
    };

    if (id && token) {
      fetchReport();
    }
  }, [id, token]);

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="flex items-center gap-3 text-slate-600">
          <Loader2 className="w-6 h-6 animate-spin" />
          <span>Loading precon report...</span>
        </div>
      </div>
    );
  }

  if (!report) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-center">
          <p className="text-slate-600 mb-4">PreCon report not found</p>
          <button 
            onClick={handleBack}
            className="text-amber-600 hover:text-amber-700 font-medium"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 print:bg-white">
      <FieldReportToolbar 
        title="PreCon Report Preview"
        onPrint={handlePrint}
        onBack={handleBack}
      />
      <div className="py-10 px-4 flex justify-center print:p-0 print:block" id="print-wrapper">
        <PreConDocument 
          report={report}
          printRef={printRef} 
        />
      </div>
    </div>
  );
}
